import { render } from "./ComposeExternal.vue?vue&type=template&id=47c8690a"
import script from "./ComposeExternal.vue?vue&type=script&lang=js"
export * from "./ComposeExternal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__